import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Navigation.css';

interface NavigationProps {
  showBack?: boolean;
  showHome?: boolean;
  backTo?: string;
  className?: string;
}

const Navigation: React.FC<NavigationProps> = ({
  showBack = true,
  showHome = true,
  backTo,
  className = '',
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backTo) {
      navigate(backTo);
    } else {
      navigate(-1);
    }
  };

  const handleHome = () => {
    navigate('/dashboard');
  };

  return (
    <div className={`navigation-container ${className}`}>
      {showBack && (
        <button className="nav-button back-button" onClick={handleBack}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M15 18l-6-6 6-6" />
          </svg>
          Back
        </button>
      )}
      {showHome && (
        <button className="nav-button home-button" onClick={handleHome}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9,22 9,12 15,12 15,22" />
          </svg>
          Home
        </button>
      )}
    </div>
  );
};

export default Navigation;
